<!-- ///////////////////////////////////////////////////// -->

<body>
    <span id="modelopensoc" data-bs-toggle="modal" data-bs-target="#clientsocedit"></span>
<div class="modal fade" id="clientsocedit" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="DataFromSOC.isEditSOC==false"> 
                    New Start Of Care 
                </h5>
                <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="DataFromSOC.isEditSOC==true">
                    Edit Start Of Care 
                </h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="Closedialog()"></button>
            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveSOCErr!=''" role="alert">
                <p>{{saveSOCErr}}</p>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveSOCErr=''"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>Start of Care<sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-7">
                        <my-date-picker [options]="myDatePickerOptions" [selDate]="startOfCare.startDate"
                            id="socSD"
                            placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchage','startDate')"
                            (dateChanged)="newdates($event,'datechagned','startDate')">
                        </my-date-picker>
                    </div>
                    <div class="col-lg-5 mt-1">
                        <label>Company <sup class="super-script">&nbsp;*</sup></label>
                    </div>
                    <div class="col-lg-7 mt-1">
                        <ng-select [items]="companyList" class="w-100" [searchable]="true" [clearable]="true"
                            id="socCompany"
                            bindLabel="Value" bindValue="Key" [(ngModel)]="startOfCare.companyId">
                        </ng-select>
                    </div>
                    <div class="col-lg-5 mt-1">
                        <label>Discharge </label>
                    </div>
                    <div class="col-lg-7 mt-1 d-flex">
                        <div *ngFor="let i of dischargeStatus">
                            <input type="radio" [value]="i.id" [(ngModel)]="startOfCare.dischargeLid"
                                id="socDischarge"
                                (ngModelChange)="getDischargeValue(i.lovName)">
                            {{i.lovName}}&nbsp;&nbsp;
                        </div>
                        <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('YESORNO')"></app-dropdown>
                    </div>
                    <div class="col-lg-5 mt-1">
                        <label>Discharge Date</label>
                    </div>
                    <div class="col-lg-7 mt-1">
                        <my-date-picker [options]="myDatePickerOptions" [disabled]="!dischargeDateDisable"
                            [selDate]="startOfCare.dischargeDate" placeholder="mm/dd/yyyy"
                            id="socDischargeDate"
                            (inputFieldChanged)="newdates($event,'inputchage','dischargeDate')"
                            (dateChanged)="newdates($event,'datechagned','dischargeDate')">
                        </my-date-picker>
                    </div>
                    <div class="col-lg-5 mt-1">
                        <label>D/C Status Code</label>
                    </div>
                    <div class="col-lg-6 mt-1">
                        <ng-select class="w-100" [items]="DCList" [searchable]="true" [clearable]="true"
                            [disabled]="!dischargeDateDisable" bindLabel="Value" bindValue="Key"
                            [(ngModel)]="startOfCare.dischargeCodeDetailId"
                            id="socSC"
                            (ngModelChange)="getDcCode(startOfCare.dischargeCodeDetailId)">
                        </ng-select>
                    </div>
                    <div class="col-lg-1 mt-1 paddingbtnl">
                        <button class="btn btn-sm btn-primary ml-1" (click)="opendischarge()"
                            [disabled]="!dischargeDateDisable">
                            <i class="fa fa-eye" id="soceye"></i>
                        </button>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Description</label>
                    </div>
                    <div class="col-lg-7">
                        <textarea class="form-control w-100" [(ngModel)]="startOfCare.description"
                            [disabled]="!dischargeDateDisable" id="socDescription"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary"
                    [disabled]="!startOfCare.startDate || !startOfCare.companyId" (click)="saveSOCRecord(startOfCare)">
                    <span *ngIf="DataFromSOC.isEditSOC==false" id="socSave"> Save & Close</span>
                    <span *ngIf="DataFromSOC.isEditSOC==true" id="socUpdate"> Update & Close</span>
                </button>
                <button type="button" class="btn btn-sm btn-primary" (click)="Closedialog()" id="socCancel">Cancel</button>
            </div>
        </div>
    </div>
</div>

<span id="dischargeopen" data-bs-toggle="modal" data-bs-target="#discharge"></span>
<div class="modal fade modalbackgrod" id="discharge" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Discharge Codes & Description</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ml-1">
                <app-discharge-codes *ngIf="enabledischage" (dataFromDC)="datchange($event)" [changevalue]="Dcvalue">
                </app-discharge-codes>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="Closedcdialog()">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="delete" data-bs-toggle="modal" data-bs-target="#deleteSCO"></span>
<div class="modal fade modalbackgrod" id="deleteSCO" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ICD-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                Do you want to delete this record?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="deleteSOC()">Yes</button>
                <button type="button" class="btn btn-sm btn-secondary" (click)="closedelete()">No</button>
            </div>
        </div>
    </div>
</div>
</body>